import { toBengaliNumerals } from "./bdNumerals";

/**
 * Formats a number into BDT using the Indian numbering system
 * (lakh / crore comma placement). e.g. 12345678.9 -> "1,23,45,678.90"
 */
export function formatIndianGrouping(value: number, fractionDigits = 2): string {
  if (!isFinite(value)) return "0";
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);
  const [intPart, decPart = ""] = abs.toFixed(fractionDigits).split(".");

  let last3 = intPart.slice(-3);
  const rest = intPart.slice(0, -3);
  const grouped = rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + last3 : last3;
  return sign + grouped + (decPart ? "." + decPart : "");
}

export function formatBDT(amount: number, lang: "en" | "bn" = "en", fractionDigits = 2): string {
  const formatted = formatIndianGrouping(amount, fractionDigits);
  const localized = lang === "bn" ? toBengaliNumerals(formatted) : formatted;
  return `৳ ${localized}`;
}
